import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { selectQuotationForm } from "app/containers/WorkOrder/redux/selector";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { formKey } from "../../../hooks/useQuoteBoxStructure";
import { useStyles } from "../styles";
import Accessories from "./Accessories";
import BoxStructure from "./BoxStructure";
import QuoteCosts from "./QuoteCosts";
import QuoteFloor from "./QuoteFloor";

const RoofBoxCurtainsQuotes = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const form = useSelector(selectQuotationForm);

  const money = (amount: string) => (
    <span dir="ltr">{t(formKey("ROOF_CURTAINS.CURRENCY"), { amount })}</span>
  );

  return (
    <>
      <Box className={styles.metricsCard}>
        <Box className={styles.metricsGrid}>
          <Box className={styles.metric}>
            <Typography className={styles.metricLabel}>
              {t("QUOTES.DETAILS.METRICS.TOTAL_SALE")}
            </Typography>
            <Typography className={styles.metricValue}>
              {money(form.totalSale)}
            </Typography>
            <Typography className={styles.profitText}>
              {t(formKey("ROOF_CURTAINS.PROFIT_LABEL"))}
              {": "}
              {money(form.profitAmount)}
              {` ${form.profitPercent}%`}
            </Typography>
          </Box>

          <Box className={styles.metric}>
            <Typography className={styles.metricLabel}>
              {t("QUOTES.DETAILS.METRICS.THEORETICAL_PRICE")}
            </Typography>
            <Typography className={styles.metricValue}>
              {money(form.theoreticalPrice)}
            </Typography>
          </Box>

          <Box className={styles.metric}>
            <Typography className={styles.metricLabel}>
              {t("QUOTES.DETAILS.METRICS.TOTAL_COST")}
            </Typography>
            <Typography className={styles.metricValue}>
              {money(form.totalCost)}
            </Typography>
          </Box>

          <Box className={styles.metric}>
            <Typography className={styles.metricLabel}>
              {t("QUOTES.DETAILS.METRICS.TOTAL_MATERIAL_COST")}
            </Typography>
            <Typography className={styles.metricValue}>
              {money(form.totalMaterialCost)}
            </Typography>
          </Box>
        </Box>
      </Box>
      <QuoteCosts />
      <QuoteFloor />
      <BoxStructure />
      <Accessories />
    </>
  );
};

export default RoofBoxCurtainsQuotes;
